module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player",
    class: {
      'cursor-none': !_vm.state.cursorShow && _vm.state.fullScreen
    },
    style: ({
      width: (_vm.state.fullScreen ? '100%' : _vm.player.width)
    })
  }, [_c('div', {
    staticClass: "player__video-wrap",
    style: ({
      height: (_vm.state.fullScreen ? '100%' : _vm.player.height)
    })
  }, [_c('div', {
    staticClass: "player__video"
  }, [_c('video', {
    attrs: {
      "poster": _vm.options.poster,
      "loop": _vm.options.loop
    },
    on: {
      "click": _vm.play
    }
  }, [_vm._v("您的浏览器不支持此播放器")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state.contrlShow || !_vm.state.fullScreen),
      expression: "state.contrlShow || !state.fullScreen"
    }],
    staticClass: "player__video-control",
    class: {
      'fix-bottom': _vm.state.fullScreen
    }
  }, [_c('div', {
    staticClass: "player__video-btn player__video-btn-start",
    on: {
      "click": _vm.play
    }
  }, [(!_vm.state.playing) ? _c('t-icon', {
    staticClass: "aid-play",
    attrs: {
      "size": "24"
    }
  }) : _c('t-icon', {
    staticClass: "aid-pause",
    attrs: {
      "size": "24"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "player__video-progress",
    on: {
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.$_onSlideDivClick($event)
      },
      "mousedown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.onVideoMoveDivClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "player__video-progress-bar pui-slider"
  }, [_c('div', {
    staticClass: "pui-slider__tracker-wrp"
  }, [_c('div', {
    staticClass: "pui-slider__tracker"
  }, [_c('div', {
    staticClass: "player__video-progress-buffer"
  }, [_c('div', {
    staticClass: "player__video-progress-buffer__range",
    style: ({
      width: _vm.video.loaded + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "pui-slider__handle",
    style: ({
      left: _vm.video.pos.current + 'px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "pui-slider__progress",
    style: ({
      width: _vm.video.pos.current + 'px'
    })
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "player__video-time"
  }, [_c('div', {
    staticClass: "video-time-wrap"
  }, [_c('span', {
    staticClass: "video-time-now"
  }, [_vm._v(_vm._s(_vm.video.displayCurrent))]), _vm._v(" "), _c('span', {
    staticClass: "video-divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "video-time-total"
  }, [_vm._v(_vm._s(_vm.video.displayDuration))])])]), _vm._v(" "), _c('div', {
    staticClass: "player__video-btn player__video-volume",
    on: {
      "mouseover": _vm.$_onVolDivMouseover
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.$_onVolMutedDivClick($event)
      }
    }
  }, [(!_vm.volume.muted && _vm.volume.percent >= 66) ? _c('t-icon', {
    staticClass: "aid-volume-high",
    attrs: {
      "size": "20"
    }
  }) : (!_vm.volume.muted && _vm.volume.percent >= 33) ? _c('t-icon', {
    staticClass: "aid-volume-medium",
    attrs: {
      "size": "20"
    }
  }) : (!_vm.volume.muted && _vm.volume.percent > 0) ? _c('t-icon', {
    staticClass: "aid-volume-low",
    attrs: {
      "size": "20"
    }
  }) : (_vm.volume.muted || _vm.volume.percent == 0) ? _c('t-icon', {
    staticClass: "aid-volume-mute",
    attrs: {
      "size": "20"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "player__video-volumebar-wrap"
  }, [_c('div', {
    staticClass: "player__video-volume-num"
  }, [_vm._v(_vm._s(_vm.volume.percent))]), _vm._v(" "), _c('div', {
    staticClass: "player__video-volumebar pui-slider pui-slider-vertical",
    on: {
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.$_onVolSlideDivClick($event)
      },
      "mousedown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.$_onVolMoveDivClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "pui-slider__tracker-wrp"
  }, [_c('div', {
    staticClass: "pui-slider__tracker"
  }, [_c('div', {
    staticClass: "pui-slider__handle",
    style: ({
      bottom: _vm.volume.pos.current + 'px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "pui-slider__progress",
    style: ({
      height: _vm.volume.pos.current + 'px'
    })
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "player__video-btn player__video-btn-fullScreen",
    on: {
      "click": _vm.fullScreen
    }
  }, [(!_vm.state.fullScreen) ? _c('t-icon', {
    staticClass: "aid-fullscreen",
    attrs: {
      "size": "20"
    }
  }) : _c('t-icon', {
    staticClass: "aid-fullscreen-exit",
    attrs: {
      "size": "20"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7459cae2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/video.vue
// module id = 385
// module chunks = 0